<script setup>
import { computed, ref } from "vue";

const step = ref(1);

const stepperProgress = computed(() => `${(100 / 3) * (step.value - 1)}%`);
</script>
<template>
  <div>
    <div class="flex items-center justify-between w-full relative z-0 mb-10">
      <div class="absolute h-1 left-2 md:left-20 right-2 md:right-20 mx-auto bg-lightgray Z-0">
        <div
          class="absolute left-0 h-full w-0 transition-all duration-200 ease-in bg-blue-600"
          :style="'width:' + stepperProgress"
        ></div>
      </div>

      <div
        v-for="item in 4"
        :key="item"
        class="flex items-center flex-row text-teal transition-all duration-700 ease-linear hover:cursor-pointer bg-white Z-10 relative space-x-5 px-3"
        @click="step = item"
      >
        <div
          class="w-16 md:w-20 h-16 md:h-20 grid rounded-full border-2 relative place-items-center shadow-lg aspect-square transition-all duration-700 ease-in-out border-lightgray text-blue-600"
          :class="[
            { 'bg-blue-400 text-white border-blue-400': step > item },
            { 'border-blue-600 bg-blue-600 text-white': step === item },
          ]"
        >
          <div v-if="item === 1">
            <span class="text-5xl font-medium font-heading">1</span>
          </div>
          <div v-if="item === 2">
            <span class="text-5xl font-medium font-heading">2</span>
          </div>
          <div v-if="item === 3">
            <span class="text-5xl font-medium font-heading">3</span>
          </div>
          <div v-if="item === 4">
            <span class="text-5xl font-medium font-heading">4</span>
          </div>
        </div>
        <span
          class="hidden lg:block font-heading text-lg font-medium"
          :class="[step > item ? 'text-blue-400' : 'text-blue-600']"
        >
          <div v-if="item === 1">Postcodegebied</div>
          <div v-if="item === 2">Persoonlijke gegevens</div>
          <div v-if="item === 3">Uw situatie</div>
          <div v-if="item === 4">Insturen</div>
        </span>
      </div>
    </div>

    <div v-for="item in 4" :key="item" :currentStep="item">
      <div v-if="step == item">
        <div v-if="item === 1" class="grid grid-cols-3 lg:grid-cols-4 xl:grid-cols-3 py-10 gap-x-10 gap-y-5">
          <div class="col-span-3 lg:col-span-1">
            <!-- // TODO vertalen  -->
            <h3 class="font-heading font-medium text-sm md:text-lg lg:text-xl xl:text-2xl text-blue-600">
              Postcodegebied
            </h3>
          </div>
          <slot name="steponecontent" />
          <div class="col-span-3 lg:col-span-1">
            <p class="mb-3">
              Geeft u aan in welk postcodegebied u woont. Dit moet u aangeven, zodat de juiste contactpersonen contact
              met u kunnen zoeken. Staat uw postcode er niet bij? Dan kunnen wij u niet helpen.
            </p>
            <button
              class="border-2 font-semibold border-pink bg-pink px-5 py-3 rounded-md text-white inline-block hover:bg-white hover:text-pink max-w-max flex-shrink-0 focus:ring focus:ring-blue transition ease-in-out duration-300"
              @click="step++"
            >
              stap vooruit
            </button>
          </div>
        </div>
        <div v-else-if="item === 2" class="grid grid-cols-3 lg:grid-cols-4 py-10 gap-x-10 gap-y-5">
          <div class="col-span-3 lg:col-span-1">
            <h3 class="font-heading font-medium text-sm md:text-lg lg:text-xl xl:text-2xl text-blue-600">
              Persoonlijke gegevens
            </h3>
          </div>
          <slot name="steptwocontent" />
          <div class="col-span-3 lg:col-span-1">
            <p class="mb-3">
              Het opgegeven e-mailadres wordt gebruikt om een kopie van uw aanvraag naar u toe te sturen.
            </p>
            <div class="flex items-center space-x-3">
              <button
                class="border-2 font-semibold border-pink bg-pink px-5 py-3 rounded-md text-white inline-block hover:bg-white hover:text-pink max-w-max flex-shrink-0 focus:ring focus:ring-blue transition ease-in-out duration-300"
                @click="step--"
              >
                stap terug
              </button>
              <button
                class="border-2 font-semibold border-pink bg-pink px-5 py-3 rounded-md text-white inline-block hover:bg-white hover:text-pink max-w-max flex-shrink-0 focus:ring focus:ring-blue transition ease-in-out duration-300"
                @click="step++"
              >
                stap vooruit
              </button>
            </div>
          </div>
        </div>
        <div v-else-if="item === 3" class="grid grid-cols-3 lg:grid-cols-4 py-10 gap-x-10 gap-y-5">
          <div class="col-span-3 lg:col-span-1">
            <!-- // TODO vertalen  -->
            <h3 class="font-heading font-medium text-sm md:text-lg lg:text-xl xl:text-2xl text-blue-600">
              Postcodegebied
            </h3>
          </div>
          <slot name="stepthreecontent" />
          <div class="col-span-3 lg:col-span-1">
            <p class="mb-3">
              Geeft u aan in welk postcodegebied u woont. Dit moet u aangeven, zodat de juiste contactpersonen contact
              met u kunnen zoeken. Staat uw postcode er niet bij? Dan kunnen wij u niet helpen.
            </p>
            <button
              class="border-2 font-semibold border-pink bg-pink px-5 py-3 rounded-md text-white inline-block hover:bg-white hover:text-pink max-w-max flex-shrink-0 focus:ring focus:ring-blue transition ease-in-out duration-300"
              @click="step++"
            >
              Verzend hulpaanvraag
            </button>
          </div>
        </div>
        <div v-else-if="item === 4" class="grid grid-cols-3 lg:grid-cols-4 py-10 gap-x-10 gap-y-5">
          <div class="col-span-3 lg:col-span-1">
            <h3 class="font-heading font-medium text-sm md:text-lg lg:text-xl xl:text-2xl text-blue-600">Insturen</h3>
          </div>
          <slot name="stepfourcontent" />
        </div>
      </div>
    </div>
  </div>
</template>
